'use strict';

angular.module('internal.trainings')
    .directive('internalTrainingNavigation', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'trainings/components/training-navigation/training-navigation.html',
            replace: true,
            controller: 'InternalNavigation'
        };
    }])
;